import type { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  icon?: CloudflareAsset;
  onClick: () => void;
  title: string;
  dataId?: string;
  description?: string;
  className?: string;
  transactionType?: string;
}

export const ActionItem = ({
  title,
  description,
  icon,
  onClick,
  className,
  transactionType,
}: Props) => {
  return (
    <div
      data-id={transactionType}
      onClick={onClick}
      className={`action-item ${className}`}
    >
      <div className="action-item--icon-wrapper">
        {icon && <CloudFlareImage path={icon}/>}
      </div>
      <div className="full-width">
        <Text
          className="action-item--title pt-8 mt-2"
          size="standard"
          weight="semibold"
          lineHeight="large"
        >
          {title}
        </Text>
      </div>
      {description && (
        <Text
          className="action-item--subtitle pt-4"
          type="tertiary"
          size="standard"
        >
          {description}
        </Text>
      )}
    </div>
  );
};
